import { memory, session, local } from 'wix-storage';
import wixWindow from 'wix-window';
import {  url } from 'wix-location';
import { fetch } from 'wix-fetch';
import { currentUser, applySessionToken, logout } from 'wix-users';
import { createWixSession } from 'backend/vdgsa-auth.jsw';

export const VDGSA_USER = 'vdgsaUser';

export async function getVdgsaSession() {
    try {
        console.log('getVdgsaSession')
        session.removeItem()
        let vdgsaUser = await fetch("https://hume.vdgsa.org/accounts/users/current/", { "method": "get", "credentials": "include" })
            .then((r) => {
                console.log('getResponse:', r)
                return r.text()
            }).then((response) => {
                console.log('vdgsaUser ', JSON.parse(response))
                return JSON.parse(response)
            })
        return vdgsaUser
    } catch (e) {
        return { error: e }
    }

}
export async function killVdgsaSession() {
    try {
        console.log('killVdgsaSession')
        session.removeItem(VDGSA_USER)
        logout();
        let vdgsaUser = await fetch("https://hume.vdgsa.org/logout/", { "method": "get" })
            .then((r) => {
                console.log('return logout', r)
               
            })
    } catch (e) {
        console.log('error logout', e)
        return { error: e }
    }

}